import React, { Component, createRef } from "react";
import { Text, View, Animated, TouchableOpacity } from "react-native";
import Icon from "react-native-vector-icons/Feather";

import Recorder from "./controller";

import { styles as buttonStyles } from "components/icon-button/styles";
import { styles } from "./styles";

export class AudioRecorder extends Component {
  recorder = createRef();

  state = { isRecording: this.recorder?.isRecording, access: "granted" };

  onAccessDenied = () => {
    this.setState({ access: "denied" });
  };

  onStartRecord = () => {
    this.recorder.current?.start();
    this.setState({ isRecording: true });
  };

  onStopRecord = () => {
    this.recorder.current?.stop();
    this.setState({ isRecording: false });
  };

  render = () => {
    let buttonBackground = [buttonStyles.button];
    let buttonText = [buttonStyles.text];
    let iconColor = buttonStyles._text?.color;
    if (this.state.isRecording) {
      buttonBackground.push(styles.recordingButton);
      buttonText.push(styles.recordingButtonText);
      iconColor = styles._recordingButtonIcon?.color;
    }

    const Wrapper = this.state.isRecording ? Flicker : View;

    const access = this.state.access === "granted";
    const text = access ? "Hold to Record" : "Allow Mic Acesss";

    return (
      <TouchableOpacity
        activeOpacity={1}
        style={buttonBackground}
        onPressIn={access && this.onStartRecord}
        onPressOut={access && this.onStopRecord}
      >
        <Recorder
          ref={this.recorder}
          onCapture={this.props.onCapture}
          onAccessDenied={this.onAccessDenied}
        />

        <Wrapper>
          <Icon
            name="mic"
            color={iconColor}
            size={buttonStyles._icon?.fontSize}
          />
        </Wrapper>
        <Text style={buttonText}> {text}</Text>
      </TouchableOpacity>
    );
  };
}

class Flicker extends Component {
  constructor(props) {
    super(props);
    this.opacity = new Animated.Value(0);
  }

  componentDidMount = () => {
    Animated.loop(
      Animated.sequence([
        Animated.timing(this.opacity, {
          toValue: 1,
          duration: 500,
          useNativeDriver: true,
        }),
        Animated.timing(this.opacity, {
          toValue: 0,
          duration: 500,
          useNativeDriver: true,
        }),
      ]),
    ).start();
  };

  render = () => {
    const containerStyle = { opacity: this.opacity };
    return (
      <Animated.View style={containerStyle}>
        {this.props.children}
      </Animated.View>
    );
  };
}
